<template>
  <div class="unread-notification">
    <div class="title k-subtitle-lg">
      <div>{{ $t('notification.popup.title') }}</div>
      <div class="k-body-md" @click="$emit('close')">
        <KkTextLink link="/affiliate/notification" :text="$t('notification.popup.action.viewAll')" />
      </div>
    </div>
    <div class="body">
      <div v-for="(item, index) in tableData" :key="index">
        <div class="list" :class="{'read': item.read}" @click="onSelectRow(item)">
          <div class="type">
            <img v-if="item.notification?.type === 'TIPS'" src="@/assets/icons/common/ic_lightbulb.svg" alt="">
            <img v-if="item.notification?.type === 'UPDATE'" src="@/assets/icons/common/ic_list.svg" alt="">
            <img v-if="item.notification?.type === 'ANNOUNCEMENT'" src="@/assets/icons/common/ic_notify.svg" alt="">
          </div>
          <div class="content">
            <div class="k-subtitle-md">{{ item.notification?.subject }}</div>
            <div class="k-body-md" style="margin-top: var(--kk-spacing-2);">{{ item.notification?.create_date }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getNotificationListApi } from '@/api/affiliate'
import dayjs from 'dayjs'

export default {
  data() {
    return {
      loading: false,
      tableData: [],
      pagination: {
        page: 1,
        pageSize: 5,
        totalCount: 0
      }
    }
  },
  created() {
    this.getNotificationList()
  },
  methods: {
    getNotificationList() {
      this.loading = true
      getNotificationListApi({
        page: this.pagination.page,
        page_size: this.pagination.pageSize
      }).then(res => {
        this.loading = false
        if (res.metadata.status === '0000') {
          this.tableData = _.map(res.data.list, function(item) {
            item.notification.create_date = item?.notification?.create_time ? dayjs(item.notification.create_time).format('YYYY/MM/DD') : ''
            return item
          })
          this.pagination.totalCount = res.metadata.pagination.total_count
          if (this.pagination.totalCount > 0) {
            this.$emit('unread', this.pagination.totalCount)
          }
        } else {
          throw ('')
        }
      }, () => {
        this.loading = false
      })
    },
    onSelectRow(val) {
      if (val?.notification_receiver_oid) {
        val.read = true
        this.pagination.totalCount -= 1
        if (this.pagination.totalCount >= 0) {
          this.$emit('unread', this.pagination.totalCount)
        }
        this.$router.push('/affiliate/notification?oid=' + val?.notification_receiver_oid)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.unread-notification {
  width: 720px;
  color: #212121;
  padding: var(--kk-spacing-7) var(--kk-spacing-8);
  box-sizing: border-box;
  .title {
    a,a:link,a:visited,a:hover,a:active{
      text-decoration: none;
      color:inherit;
    }
    display: flex;
    justify-content: space-between;
    .see-all {
      border-bottom: 1px solid #212121;
      cursor: pointer;
    }
  }
  .body {
    margin-top: var(--kk-spacing-5);
    height: 340px;
    .list {
      cursor: pointer;
      display: flex;
      align-items: center;
      padding: var(--kk-spacing-4) var(--kk-spacing-5);
      border-bottom: 1px solid var(--kk-border-color-border-lighter, #E6E9ED);
      box-sizing: border-box;
      background-color: #F0FAFB;
      .type {
        display: flex;
      }
      .content {
        margin-left: var(--kk-spacing-7);
      }
    }
    .read {
      background-color: #FFFFFF;
    }
  }
}
</style>
